module.exports = __webpack_public_path__ + "static/media/03_game_play_paused.2dfff74b.jpg";